<template>
  <div id="account-change-password" class="app-change-password-wrapper content-wrapper">
    <div class="content-width">
      <h1 class="sr-only">Passwort ändern – Konto & Service</h1>
      <h2 class="text-3xl text-align-left full-width">Passwort ändern</h2>
      <div class="container-box">
        <div class="content-limiter">
          <ChangePasswordEdit
            ref="ChangePasswordEdit"
            :old-password.sync="oldPassword"
            :new-password.sync="newPassword"
            :invalid.sync="invalid"
          >
            <template v-for="slot in possibleChildSlotsFor('Edit')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </ChangePasswordEdit>
          <Stepper :loading-next="loading" @next="savePassword" @prev="back" :disabled-next="loading">
            <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </Stepper>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ChangePasswordEdit from '@/components-v2/flows/LIDL/Password/ChangePassword/Edit.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '../../../../../../mixins/slotProxy'
import Stepper from '../../../../../generic/Stepper.vue'
import { mapActions } from 'vuex'

export default {
  name: 'ChangePasswordWrapper',
  components: { Stepper, ChangePasswordEdit },
  data() {
    return {
      oldPassword: null,
      newPassword: null,
      invalid: true,
      loading: false
    }
  },
  methods: {
    ...mapActions('changePassword', ['changePassword']),
    async reset() {
      await this.$refs.ChangePasswordEdit.reset()
    },
    savePassword() {
      this.$refs.ChangePasswordEdit.$refs.Password.markInputAsDirty()
      this.$refs.ChangePasswordEdit.$refs.PasswordWithRepeat.$refs.Password.markInputAsDirty()
      this.$refs.ChangePasswordEdit.$refs.PasswordWithRepeat.$refs.Repeat.markInputAsDirty()
      if (this.invalid) {
        return
      }
      this.loading = true
      this.changePassword({
        changePasswordData: {
          oldPassword: this.oldPassword,
          password: this.newPassword
        }
      }).then(
        () => {
          this.loading = false
          this.reset()
        },
        () => {
          this.loading = false
          this.reset()
        }
      )
    },
    back() {
      history.back()
    }
  },
  mixins: [transaction('changePassword'), slotProxy()]
}
</script>
